import { Grid } from '@mui/material';

import { tss } from 'tss-react/mui';

import { Or2Link } from '@/components/navigation/Or2Link';

import { Or2Image } from '@/components/image/Or2Image';

import OwlHelpLogo from 'Images/help_owl.png';

import { graphql, type DocumentType } from '@/gql';
import { extractConnectionProps } from '@/utils/queries/queryExtracts';

const ASSISTANT_AI_RESPONSE_INTERCOM_ARTICLES_RESPONSE_FRAGMENT = graphql(`
  fragment assistantAiResponseIntercomArticlesResponseFields on OrtooGptConversationItemResponse {
    intercomSourcesConnection {
      edges {
        node {
          title
          url
        }
      }
    }
  }
`);

interface Props {
  response: DocumentType<
    typeof ASSISTANT_AI_RESPONSE_INTERCOM_ARTICLES_RESPONSE_FRAGMENT
  >;
}

const useStyles = tss.create(() => ({
  image: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const AssistantAiResponseIntercomArticles = ({ response }: Props) => {
  const { classes } = useStyles();

  const { intercomSourcesConnection } = response;

  const intercomSources = extractConnectionProps(intercomSourcesConnection);

  return (
    <Grid container spacing={1}>
      <Grid container direction="column" spacing={1}>
        {intercomSources.map((intercomSource, index) => {
          const { title, url } = intercomSource;

          return (
            <Grid container key={index} alignItems="center">
              <Grid>
                <Or2Image
                  className={classes.image}
                  src={OwlHelpLogo}
                  alt="The GovernorHub Help Logo"
                  size={32}
                />
              </Grid>
              {url && (
                <Grid>
                  <Or2Link href={url} isExternal>
                    {title}
                  </Or2Link>
                </Grid>
              )}
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};
